import { useEffect } from "react";
import { useQuery } from "react-query";
import { quizAttemptsApi } from "@/react/api/quizAttemptsApi";
import type { CoursesLesson } from "@/react/types/CoursesLesson";
import type { QuizAttempt } from "@/react/types/QuizAttempt";

interface UseGetLastQuizAttemptParams {
  lesson: CoursesLesson;
  setLastAttempt: (attempt: QuizAttempt) => void;
}
export const useGetLastQuizAttempt = ({
  lesson,
  setLastAttempt,
}: UseGetLastQuizAttemptParams) => {
  const isForAdminReview = false;
  const { isLoading, data } = useQuery({
    queryKey: [
      "attempts",
      lesson?.quiz?.id,
      lesson?.latest_quiz_attempt_id,
      isForAdminReview,
    ],
    enabled: !!lesson && !!lesson.latest_quiz_attempt_id && !!lesson.quiz,
    queryFn: () => {
      if (!lesson.quiz || !lesson.latest_quiz_attempt_id) return null;
      return quizAttemptsApi.show({
        quizId: lesson.quiz.id,
        id: lesson.latest_quiz_attempt_id,
      });
    },
  });

  useEffect(() => {
    setLastAttempt(data);
  }, [data, setLastAttempt]);

  return { isLoadingLastAttempt: isLoading };
};
